import { Injectable } from '@angular/core';
import { FilterListItem, FilterTypes, RiskFilterType, SelectFilterOption } from '../models/risk-filter-type';
import { Observable, of } from 'rxjs';
import { EntityType } from '../models/entity-type';
import { ListSortModel, PagedListModel } from '../models/list-sort-model';

export abstract class AgilityRiskFilterService {
  abstract getFilterOptions(serverDataType: FilterTypes): Observable<Array<SelectFilterOption>>;

  abstract getFiltersForComponent(componentSelector: string): Observable<Array<FilterListItem>>;

  abstract getFilteredUsers(filters: Array<RiskFilterType>, sort: Array<ListSortModel>, pageNumber: number, pageSize: number, elementsToExclude?: string[], thirdParty?: boolean): Observable<PagedListModel>;

  abstract getFilteredDepartments(filters: Array<RiskFilterType>, sort: Array<ListSortModel>, pageNumber: number, pageSize: number): Observable<PagedListModel>;

  abstract getFilteredSites(filters: Array<RiskFilterType>, sort: Array<ListSortModel>, pageNumber: number, pageSize: number): Observable<PagedListModel>;

  abstract getFilteredVendors(filters: Array<RiskFilterType>, sort: Array<ListSortModel>, pageNumber: number, pageSize: number): Observable<PagedListModel>;

  abstract getFilteredResources(filters: Array<RiskFilterType>, sort: Array<ListSortModel>, pageNumber: number, pageSize: number): Observable<PagedListModel>;

  abstract getFilteredTemplates(filters: Array<RiskFilterType>): Observable<PagedListModel>;
}

@Injectable()
export class FilterDummyService implements AgilityRiskFilterService {
  locations: Array<SelectFilterOption> = [
    new SelectFilterOption('Atlanta', '1'),
    new SelectFilterOption('Boston', '2')
  ];

  departments: Array<SelectFilterOption> = [
    new SelectFilterOption('Software Development', '1'),
    new SelectFilterOption('Implementation', '2')
  ];

  userFiltersForApp: Array<FilterListItem> = [
    new FilterListItem(0, 'Name', FilterTypes.name),
    new FilterListItem(1, 'Department', FilterTypes.userDepartment),
    new FilterListItem(2, 'Location', FilterTypes.userLocation),
    new FilterListItem(3, 'Department by name', FilterTypes.departmentByName)];

  getFilterOptions(serverDataType: FilterTypes): Observable<Array<SelectFilterOption>> {
    switch (serverDataType) {
      case FilterTypes.userLocation:
        return of(this.locations);
      case FilterTypes.userDepartment:
        return of(this.departments);
    }
    return of(null);
  }

  getFiltersForComponent(componentSelector: string): Observable<Array<FilterListItem>> {
    switch (componentSelector) {
      case EntityType.user:
        return of(this.userFiltersForApp);
      default:
        return of([]);
    }
  }

  getFilteredUsers(filters: Array<RiskFilterType>, sort: Array<ListSortModel>, pageNumber: number, pageSize: number, elementsToExclude?: string[]): Observable<PagedListModel> {
    return of();
  }

  getFilteredDepartments(filters: Array<RiskFilterType>, sort: Array<ListSortModel>, pageNumber: number, pageSize: number): Observable<PagedListModel> {
    return of();
  }

  getFilteredSites(filters: Array<RiskFilterType>, sort: Array<ListSortModel>, pageNumber: number, pageSize: number): Observable<PagedListModel> {
    return of();
  }

  getFilteredVendors(filters: Array<RiskFilterType>, sort: Array<ListSortModel>, pageNumber: number, pageSize: number): Observable<PagedListModel> {
    return of();
  }

  getFilteredResources(filters: Array<RiskFilterType>, sort: Array<ListSortModel>, pageNumber: number, pageSize: number): Observable<PagedListModel> {
    return of();
  }

  getFilteredTemplates(filters: Array<RiskFilterType>): Observable<PagedListModel> {
    return of();
  }
}
